import api from 'service/api'

const dponetAPI = api.create('dponet')

const list = async (params) => {
  return await dponetAPI.get('/advisors/organizations', { params })
}

const select = async (organizationId) => {
  return await dponetAPI.get(
    `/advisors/organization_users/${organizationId}/select`,
  )
}

export default {
  list,
  select,
}
